/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const OrderTrackingListRequestDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const OrderTrackingListRequestDTOPackageStatusesEnum = {
    NotPurchased: 'NOT_PURCHASED',
    SubmittedToWh: 'SUBMITTED_TO_WH',
    GoingToWh: 'GOING_TO_WH',
    AtWh: 'AT_WH',
    AtWhPaymentPending: 'AT_WH_PAYMENT_PENDING',
    AtWhReturnLabelPending: 'AT_WH_RETURN_LABEL_PENDING',
    Returned: 'RETURNED',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Disposed: 'DISPOSED'
};
/**
 * @export
 */
export const OrderTrackingListRequestDTOTrackingCheckStatusesEnum = {
    NoTracking: 'NO_TRACKING',
    Match: 'MATCH',
    Mismatch: 'MISMATCH'
};
/**
 * @export
 */
export const OrderTrackingListRequestDTOOrderStatusesEnum = {
    PendingAvailability: 'PENDING_AVAILABILITY',
    Pending: 'PENDING',
    Unshipped: 'UNSHIPPED',
    PartiallyShipped: 'PARTIALLY_SHIPPED',
    Shipped: 'SHIPPED',
    InvoiceUnconfirmed: 'INVOICE_UNCONFIRMED',
    Cancelled: 'CANCELLED',
    Unfulfillable: 'UNFULFILLABLE'
};
/**
 * Check if a given object implements the OrderTrackingListRequestDTO interface.
 */
export function instanceOfOrderTrackingListRequestDTO(value) {
    return true;
}
export function OrderTrackingListRequestDTOFromJSON(json) {
    return OrderTrackingListRequestDTOFromJSONTyped(json, false);
}
export function OrderTrackingListRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'search': json['search'] == null ? undefined : json['search'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'packageStatuses': json['packageStatuses'] == null ? undefined : json['packageStatuses'],
        'delayed': json['delayed'] == null ? undefined : json['delayed'],
        'remainingDays': json['remainingDays'] == null ? undefined : json['remainingDays'],
        'trackingCheckStatuses': json['trackingCheckStatuses'] == null ? undefined : json['trackingCheckStatuses'],
        'orderStatuses': json['orderStatuses'] == null ? undefined : json['orderStatuses'],
        'excludeCancelled': json['excludeCancelled'] == null ? undefined : json['excludeCancelled'],
        'dueSoon': json['dueSoon'] == null ? undefined : json['dueSoon'],
        'trackingMismatch': json['trackingMismatch'] == null ? undefined : json['trackingMismatch'],
        'noTracking': json['noTracking'] == null ? undefined : json['noTracking'],
        'notPurchased': json['notPurchased'] == null ? undefined : json['notPurchased'],
        'amazonConfirmationMissing': json['amazonConfirmationMissing'] == null ? undefined : json['amazonConfirmationMissing'],
        'awaitingWarehouseReceipt': json['awaitingWarehouseReceipt'] == null ? undefined : json['awaitingWarehouseReceipt'],
        'supplierDelayed': json['supplierDelayed'] == null ? undefined : json['supplierDelayed'],
        'supplierNotArriving': json['supplierNotArriving'] == null ? undefined : json['supplierNotArriving'],
        'purchaseDateFrom': json['purchaseDateFrom'] == null ? undefined : (new Date(json['purchaseDateFrom'])),
        'purchaseDateTo': json['purchaseDateTo'] == null ? undefined : (new Date(json['purchaseDateTo'])),
        'shipByDateFrom': json['shipByDateFrom'] == null ? undefined : (new Date(json['shipByDateFrom'])),
        'shipByDateTo': json['shipByDateTo'] == null ? undefined : (new Date(json['shipByDateTo'])),
        'deliverByDateFrom': json['deliverByDateFrom'] == null ? undefined : (new Date(json['deliverByDateFrom'])),
        'deliverByDateTo': json['deliverByDateTo'] == null ? undefined : (new Date(json['deliverByDateTo'])),
        'flagIds': json['flagIds'] == null ? undefined : json['flagIds'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}
export function OrderTrackingListRequestDTOToJSON(json) {
    return OrderTrackingListRequestDTOToJSONTyped(json, false);
}
export function OrderTrackingListRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'search': value['search'],
        'marketplace': value['marketplace'],
        'packageStatuses': value['packageStatuses'],
        'delayed': value['delayed'],
        'remainingDays': value['remainingDays'],
        'trackingCheckStatuses': value['trackingCheckStatuses'],
        'orderStatuses': value['orderStatuses'],
        'excludeCancelled': value['excludeCancelled'],
        'dueSoon': value['dueSoon'],
        'trackingMismatch': value['trackingMismatch'],
        'noTracking': value['noTracking'],
        'notPurchased': value['notPurchased'],
        'amazonConfirmationMissing': value['amazonConfirmationMissing'],
        'awaitingWarehouseReceipt': value['awaitingWarehouseReceipt'],
        'supplierDelayed': value['supplierDelayed'],
        'supplierNotArriving': value['supplierNotArriving'],
        'purchaseDateFrom': value['purchaseDateFrom'] == null ? undefined : ((value['purchaseDateFrom']).toISOString()),
        'purchaseDateTo': value['purchaseDateTo'] == null ? undefined : ((value['purchaseDateTo']).toISOString()),
        'shipByDateFrom': value['shipByDateFrom'] == null ? undefined : ((value['shipByDateFrom']).toISOString()),
        'shipByDateTo': value['shipByDateTo'] == null ? undefined : ((value['shipByDateTo']).toISOString()),
        'deliverByDateFrom': value['deliverByDateFrom'] == null ? undefined : ((value['deliverByDateFrom']).toISOString()),
        'deliverByDateTo': value['deliverByDateTo'] == null ? undefined : ((value['deliverByDateTo']).toISOString()),
        'flagIds': value['flagIds'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}
